import script from "./TradeCount.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeCount.vue?vue&type=script&setup=true&lang=js"

import "./TradeCount.vue?vue&type=style&index=0&id=b1c959d0&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1c959d0"]])

export default __exports__